/* @flow */
// typecheck: ignore file
import React from 'react';
import Input from 'components/Input.jsx';
import Button from 'components/Button.jsx';
import StripeAPI from 'lib/StripeAPI';
import SettingsStore from 'stores/SettingsStore';
import Field from 'components/Field.jsx';

import './styles/StripePersonalNumberForm.scss';

function isSSN(value) {
  return /^[0-9]{3}\-?[0-9]{2}\-?[0-9]{4}$/.test(value);
}

type Props = {
  onValidSubmit: (token: string) => void,
  disabled: boolean,
};

type State = {
  personalIdNumber: ?string,
  proccessing: boolean,
  error?: string,
}

class StripePersonalNumberForm extends React.Component {
  props: Props;

  state: State = {
    personalIdNumber: null,
    proccessing: false,
  };

  componentDidMount() {
    StripeAPI.setPublishableKey(SettingsStore.getStripeKey());
  }

  onKeyUp = () => {
    if (this.state.error) {
      if (isSSN(this.state.personalIdNumber || '')) {
        this.setState({ error: undefined });
      }
    }
  }

  submit = () => {
    if (!isSSN(this.state.personalIdNumber || '')) {
      this.setState({ error: 'Invalid ssn format' });
      return;
    }

    if (this.state.error) {
      this.setState({ error: undefined });
    }

    this.setState({ proccessing: true });

    StripeAPI.createPIIToken({ personal_id_number: this.state.personalIdNumber }, (status, response) => {
      if (response.error) {
        this.setState({ error: response.error.message });
      } else {
        this.props.onValidSubmit(response.id);
      }

      this.setState({ proccessing: false });
    });
  }

  onChange = (event: any) => {
    if (event.target) {
      this.setState({ personalIdNumber: event.target.value });
    }
  }

  render() {
    return (
      <div className="StripePersonalNumberForm">
        <Field error={this.state.error} className="StripePersonalNumberForm-field">
          <Input
            placeholder="000-00-0000"
            name="personal_id_number"
            onChange={this.onChange}
            onKeyUp={this.onKeyUp}
          />
        </Field>
        <div>
          <Button
            disabled={this.state.proccessing || this.props.disabled}
            type="submit"
            size="small"
            onClick={this.submit}>
            Save
          </Button>
        </div>
      </div>
    );
  }
}

export default StripePersonalNumberForm;



// WEBPACK FOOTER //
// ./src/payments/components/StripePersonalNumberForm.jsx